import React, { Component } from 'react';
import { formatMoney } from './BreakdownHelpers';
import NotesPopup from '../../NotesPopup/NotesPopupContainer';

export default class NeedsAnalysisView extends Component {
  render() {
    const {
      isAdviserArea,
      breakdown,
      note,
      hasPassiveIncome,
      onNotesClick,
      clientId,
      goalId,
      subgoalId,
      isCurrentPlan,
    } = this.props;

    return (
      <div className="NewFinancialPlan_Insurance_Breakdown">
        <section>
          <NotesPopup {...this.props} />
          <ul>
            <li className="breakdown-item">
              <span className="breakdown-text">
                <span>Monthly Salary</span>
                <span className="pill">{formatMoney(breakdown.MonthlySalary)}</span>
              </span>
            </li>
            <li className="breakdown-item">
              <span className="breakdown-text">
                <span>
                  Coverage Limit <span className="blue">60% of base Income</span>
                </span>
                <span className="pill">{formatMoney(breakdown.CoverageLimit)}</span>
              </span>
            </li>
            {hasPassiveIncome && (
              <li className="breakdown-item">
                <span className="breakdown-text">
                  <span>Passive Income</span>
                  <span className="pill">{formatMoney(breakdown.PassiveIncome)}</span>
                </span>
              </li>
            )}

            <li className="breakdown-item">
              <span className="breakdown-text">
                <span>Coverage Need</span>
                <span className="pill">{formatMoney(breakdown.CoverageNeed)}</span>
              </span>
            </li>
          </ul>
          <div className="notes">
            <header>
              <span className="recommendations">Recommendation</span>
              {isAdviserArea && !isCurrentPlan && (
                <strong>
                  <a onClick={onNotesClick(clientId, goalId, subgoalId, note.Description)}>
                    <i className="far fa-edit" /> Edit
                  </a>
                </strong>
              )}
            </header>
            <p className="adv-scrollbars">{note.Description}</p>
          </div>
        </section>
      </div>
    );
  }
}
